import { Icon } from "dash-ui";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { SUBSCRIPTION_COLORS } from "../SubscriptionComponents.constants";

interface ISubscriptionErrorFallbackProps {
  message?: string;
}

const RefreshButton = styled.button`
  padding: 0.5rem 1.5rem;
  border-radius: 0.375rem;
  font-weight: 500;
  font-size: 0.875rem;
  transition: background-color 0.2s;
  background-color: ${SUBSCRIPTION_COLORS.primary};
  color: #ffffff;

  &:hover {
    background-color: #2c6ba0;
  }
`;

/**
 * Error fallback UI for subscription-related errors
 * Displays a user-friendly error message when subscription data fails to load
 */
export default function SubscriptionErrorFallback({
  message,
}: ISubscriptionErrorFallbackProps) {
  const { t } = useTranslation("pages");
  return (
    <div className="flex flex-col items-center justify-center p-8 min-h-[400px]">
      <div className="flex flex-col items-center max-w-md text-center gap-4">
        {/* Error Icon */}
        <div
          className="rounded-full p-4"
          style={{ backgroundColor: "#FEF2F2" }}
        >
          <Icon name="warningFilled" size={48} color="#DC2626" />
        </div>

        {/* Error Title */}
        <h3
          className="text-xl font-semibold"
          style={{ color: SUBSCRIPTION_COLORS.secondaryText }}
        >
          {t("subscriptionPlans.errorTitle")}
        </h3>

        {/* Error Message */}
        <p
          className="text-sm"
          style={{ color: SUBSCRIPTION_COLORS.featureText }}
        >
          {message ?? t("subscriptionPlans.errorLoading")}
        </p>

        {/* Action Button */}
        <div className="flex gap-3 mt-4">
          <RefreshButton onClick={() => window.location.reload()}>
            {t("subscriptionPlans.refreshPage")}
          </RefreshButton>
        </div>

        {/* Support Text */}
        <p
          className="text-xs mt-4"
          style={{ color: SUBSCRIPTION_COLORS.featureText }}
        >
          {t("subscriptionPlans.errorSupport")}
        </p>
      </div>
    </div>
  );
}
